import { ReactNode, Suspense } from "react";
import { Navbar } from "@/components/Navbar";
import { ServiceBreadcrumb } from "./ServiceBreadcrumb";
import { ServiceLoading } from "./ServiceLoading";
import { Footer } from "@/components/Footer";

interface ServiceLayoutProps {
  children: ReactNode;
  serviceName: string;
  className?: string;
}

export const ServiceLayout = ({ children, serviceName, className = "" }: ServiceLayoutProps) => {
  return (
    <Suspense fallback={<ServiceLoading />}>
      <div className={`min-h-screen ${className}`}>
        <Navbar />
        <ServiceBreadcrumb serviceName={serviceName} />
        <main>
          {children}
        </main>
        <Footer />
      </div>
    </Suspense>
  );
};